module.exports = __webpack_public_path__ + "img/goods3_3.5eb274d5.jpg";